export default __webpack_public_path__ + "static/media/plot.f910a2c0.png";